export const generateRandomAlphabeticString = (length: number): string => {
  const a = new Array(length)
    .fill(0)
    .map(() => Math.floor(Math.random() * 25) + 65);

  return String.fromCharCode(...a);
};

export const capitalize = (str: string): string => {
  return str
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const parseFilterValue = (raw: string | null): string[] => {
  if (!raw) return [];

  try {
    const parsed = JSON.parse(raw);

    if (Array.isArray(parsed)) {
      return parsed;
    }

    return [raw];
  } catch {
    return [raw];
  }
};

export const uniqueByName = <T extends { name: string }>(items: T[]): T[] => {
  return [...new Map(items.map((i) => [i.name, i])).values()];
};
